export const MESSAGE = {
    // Page & Section Titles
    PAGE_TITLE: "Messages",
    
    // Welcome Container
    WELCOME_SELECT_CONVERSATION: "Select a conversation from the list or start a new one to begin messaging.",
    WELCOME_START_CONVERSATION: "Start a conversation",
    NEW_MESSAGE_BUTTON: "New Message",
    
    // Chat List
    CHAT_LIST_NO_CONVERSATIONS: "No conversations yet",
    CHAT_LIST_NO_MESSAGES: "No messages yet",
    CHAT_LIST_LOADING_MORE: "Loading more conversations...",
    CHAT_LIST_SENT_A_TIP: "Sent a tip",
    CHAT_LIST_MEDIA: "Media",
    CHAT_LIST_MEDIA_BRACKET: "[Media]",
    CHAT_LIST_YOU_PREFIX: "You: ",
    CHAT_LIST_YESTERDAY: "Yesterday",
    SEARCH_PLACEHOLDER: "Search messages...",
    UNKNOWN_USER: "Unknown User",
    
    // Conversation View
    CONVERSATION_VIEW_LOADING_MESSAGES: "Loading messages...",
    CONVERSATION_VIEW_BLOCKED_BY_USER: "You've been blocked and cannot send messages",
    CONVERSATION_VIEW_BLOCKED_BY_YOU: "Unblock this user to continue messaging",
    CONVERSATION_VIEW_SUBSCRIBE_PROMPT: "Subscribe to start messaging",
    CONVERSATION_VIEW_MESSAGES_DISABLED: "This user has disabled messages",
    SCROLL_TO_LATEST: "Scroll to latest messages",
    SCOLL_TO_BOTTOM: "Scroll to bottom",
    GO_TO_PROFILE_BUTTON: "Go to Profile",
    
    // Input Area
    INPUT_PLACEHOLDER: "Type a message...",
    DROP_MEDIA_HERE: "Drop media files here",
    
    // Format Toolbar
    FORMAT_BOLD: "Bold",
    FORMAT_ITALIC: "Italic",
    FORMAT_LIST: "List",
    FORMAT_ADD_MEDIA: "Add Media",
    FORMAT_SET_PRICE: "Set Price",
    FORMAT_TAG_CREATORS: "Tag verified creators",
    
    // Typing Indicator
    TYPING_INDICATOR_DEFAULT_USERNAME: "Someone",
    TYPING_INDICATOR_SUFFIX: "is typing",
    TYPING_MULTIPLE: "people are typing...",
    
    // Reply
    REPLYING_TO: "Replying to",
    REPLY_UNKNOWN_SENDER: "Unknown",
    REPLY_MEDIA_SUFFIX: "media",
    REPLY_MEDIA_ITEM: "media item",
    REPLY_MEDIA_ITEMS: "media items",
    REPLY_MESSAGE_FALLBACK: "Message",
    REPLY_CANCEL: "Cancel reply",
    LOADING_ORIGINAL_MESSAGE: "Loading original message...",
    CLICK_TO_SCROLL_ORIGINAL: "Click to scroll to original message",
    LOADING: "Loading...",
    
    // Reactions
    REACTION_ALREADY_REACTED: "Already reacted",
    REACTION_TITLE_LOVE: "React with love",
    REACTION_TITLE_LIKE: "React with like",
    REACTION_TITLE_LAUGH: "React with laugh",
    REACTION_TITLE_FIRE: "React with fire",
    CLICK_TO_REMOVE_REACTION: "Click to remove your reaction",
    CANNOT_REMOVE_OTHERS_REACTION: "Cannot remove others' reactions",
    
    // Message Menu Actions
    MENU_ACTION_REPLY: "Reply to message",
    MENU_ACTION_COPY: "Copy Text",
    MENU_ACTION_DELETE: "Delete Message",
    MENU_ACTION_REPORT: "Report Message",
    MENU_ACTION_MORE: "More options",
    
    // User Actions Modal
    CHOOSE_ACTION: "Choose an action",
    MUTING: "Muting...",
    UNMUTING: "Unmuting...",
    BLOCKING: "Blocking...",
    UNBLOCKING: "Unblocking...",
    MUTE_USER_PREFIX: "Mute @",
    UNMUTE_USER_PREFIX: "Unmute @",
    BLOCK_USER_PREFIX: "Block @",
    UNBLOCK_USER_PREFIX: "Unblock @",
    MUTE_DESCRIPTION: "Muted users' posts won't appear in your feed, but you can still message them.",
    BLOCKED_DESCRIPTION: "Blocked users can't see your profile or message you.",
    UNBLOCKED_DESCRIPTION: "Unblock to see their posts and message them again.",
    BLOCK_REASON_DEFAULT: "Blocked from messages",
    SEND_TIP_BUTTON: "Send Tip",
    
    // Toast Messages - Success
    NOT_FOUND_TOAST: "Message not found. Please try again.",
    CONTENT_UNLOCKED_TOAST: "Content unlocked successfully!",
    CONTENT_UNLOCKED_TOAST_LEGACY: "Content unlocked successfully! Please refresh to see updated content.",
    MUTED_TOAST_SUCCESS: " has been muted. Their posts won't appear in your feed.",
    UNMUTED_TOAST_SUCCESS: " has been unmuted.",
    BLOCKED_TOAST_SUCCESS: " has been blocked.",
    UNBLOCKED_TOAST_SUCCESS: " has been unblocked.",
    TIP_SUCCESS_PREFIX: "Tip of $",
    TIP_SUCCESS_SUFFIX: " sent successfully!",
    
    // Toast Messages - Error
    FAILED_OPEN_PAYMENT_MODAL_TOAST: "Failed to open payment modal. Please try again.",
    FAILED_MUTE_TOAST: "Failed to mute user. Please try again.",
    FAILED_UNMUTE_TOAST: "Failed to unmute user. Please try again.",
    FAILED_BLOCK_TOAST: "Failed to block user. Please try again.",
    FAILED_UNBLOCK_TOAST: "Failed to unblock user. Please try again.",
    
    // Console Errors
    CONSOLE_ERROR_LOADING_MESSAGES: "Error loading messages:",
    CONSOLE_MUTE_FAILED: "Failed to mute user:",
    CONSOLE_UNMUTE_FAILED: "Failed to unmute user:",
    CONSOLE_BLOCK_FAILED: "Failed to block user:",
    CONSOLE_UNBLOCK_FAILED: "Failed to unblock user:",
    CONSOLE_DELETE_MESSAGE_FAILED: "Failed to delete message:",
    CONSOLE_SEND_MESSAGE_FAILED: "Message sending failed:",
    
    // Payment Modal
    PAYMENT_MODAL_DESCRIPTION: "Unlock message content",
    
    // Unlock Content Button
    UNLOCK_LOCKED_ITEM: "locked item",
    UNLOCK_LOCKED_ITEMS: "locked items",
    UNLOCK_MEDIA_VIDEO: "Video",
    UNLOCK_MEDIA_VOICE: "Voice",
    UNLOCK_MEDIA_IMAGE: "Image",
    UNLOCK_MEDIA_FILE: "File",
    UNLOCK_TO_VIEW: "Unlock to View",
    
    // Message Bubble
    PROCESSING_CONTENT: "Processing content...",
    UNLOCKED_STATUS: "Unlocked",
    LOCKED_MEDIA_PREFIX: "This message contains",
    LOCKED_MEDIA_ITEM: "locked media item",
    LOCKED_MEDIA_ITEMS: "locked media items",
}

export const NAVIGATION = {
    // More Menu Labels
    CIRCLES: "Circles",
    LISTS: "Circles", // Backward compatibility alias
    DASHBOARD: "Dashboard",
    SETTINGS: "Settings",
    MY_PROFILE: "My Profile",
    HELP_SUPPORT: "Help & Support",
    MY_PURCHASES: "Owned Content",
    MY_SUBSCRIPTIONS: "My Subscriptions",
    LOGOUT: "Logout",
}

export const AUTH = {
    // Tagline
    TAGLINE_CREATE: "CREATE,",
    TAGLINE_SHARE: "SHARE,",
    TAGLINE_CONNECT: "CONNECT,",
    TAGLINE_REPEAT: "REPEAT!",
    
    // Tabs
    TAB_LOGIN: "Log In",
    TAB_SIGNUP: "Sign Up",
    
    // Labels
    LABEL_EMAIL: "Email",
    LABEL_PASSWORD: "Password",
    LABEL_NAME: "Name",
    
    // Placeholders
    PLACEHOLDER_EMAIL: "Email",
    PLACEHOLDER_PASSWORD: "Password",
    PLACEHOLDER_ENTER_NAME: "Enter your name",
    PLACEHOLDER_ENTER_EMAIL: "Enter your email",
    PLACEHOLDER_CREATE_PASSWORD: "Create password",
    
    // Buttons
    BUTTON_LOGIN: "Log In",
    BUTTON_CREATE_ACCOUNT: "Create Account",
    
    // Age & Terms Confirmation
    AGE_TERMS_PREFIX: "By signing up, you confirm you are at least 18 years old and agree to our ",
    LOGIN_TERMS_PREFIX: "By logging in, you confirm you are at least 18 years old and agree to our ",
    TERMS_LINK_TEXT: "Terms of Service",
    TERMS_SUFFIX: ".",
    
    // Links
    FORGOT_PASSWORD: "Forgot password?",
    
    // Dividers
    DIVIDER_CONTINUE_WITH: "or continue with",
    DIVIDER_SIGNUP_WITH: "or sign up with",
    
    // Footer
    FOOTER_NO_ACCOUNT: "Don't have an account?",
    FOOTER_SIGNUP_LINK: "Sign up",
    FOOTER_HAS_ACCOUNT: "Already have an account?",
    FOOTER_LOGIN_LINK: "Log in",
    
    // Error Messages
    ERROR_FILL_ALL_FIELDS: "Please fill in all fields",
    ERROR_AUTH_FAILED: "Authentication failed. Please try again.",
    ERROR_LOGIN_FAILED: "Failed to log in. Please try again.",
    ERROR_INVALID_CREDENTIALS: "Invalid email/username or password",
    ERROR_ACCOUNT_DISABLED: "Your account has been disabled. Please contact support.",
    ERROR_ACCOUNT_LOCKED: "Account is temporarily locked. Please try again later.",
    ERROR_TOO_MANY_ATTEMPTS: "Too many login attempts. Please try again later.",
    ERROR_SIGNUP_FAILED: "Failed to sign up. Please try again.",
    ERROR_SOCIAL_LOGIN_FAILED: "login failed. Please try again.",
    
    // Email Verification Modal
    VERIFY_EMAIL_TITLE: "Verify Your Email",
    VERIFY_EMAIL_SENT_TO: "We've sent a verification email to",
    VERIFY_EMAIL_CHECK_INBOX: "Please check your inbox and click the verification link to continue using Experience.",
    VERIFY_EMAIL_SUCCESS: "Verification email sent! Please check your inbox.",
    VERIFY_EMAIL_FAILED: "Failed to resend verification email",
    VERIFY_EMAIL_SENDING: "Sending...",
    VERIFY_EMAIL_RESEND: "Resend Email",
    VERIFY_EMAIL_HELP: "Didn't receive the email? Check your spam folder or click \"Resend Email\" above.",
    
    // Password Requirements
    PASSWORD_REQUIREMENTS_TITLE: "Password requirements",
    PASSWORD_STRENGTH_WEAK: "Weak",
    PASSWORD_STRENGTH_MEDIUM: "Medium",
    PASSWORD_STRENGTH_GOOD: "Good",
    PASSWORD_STRENGTH_STRONG: "Strong",
    PASSWORD_REQ_LENGTH: "8+ characters",
    PASSWORD_REQ_DIGIT: "One number",
    PASSWORD_REQ_LOWERCASE: "Lowercase letter",
    PASSWORD_REQ_UPPERCASE: "Uppercase letter",
    PASSWORD_REQ_SPECIAL: "Special character",
    PASSWORD_REQ_NO_SPACES: "No spaces",
    
    // Password Reset Modal
    RESET_VALIDATING_TITLE: "Validating Reset Link",
    RESET_VALIDATING_MESSAGE: "Please wait while we validate your reset link...",
    RESET_INVALID_TITLE: "Invalid Reset Link",
    RESET_INVALID_MESSAGE: "The password reset link is invalid or has expired.",
    RESET_INVALID_OR_EXPIRED: "Invalid or expired reset link",
    RESET_REQUEST_NEW_LINK: "Request New Link",
    RESET_FORGOT_TITLE: "Forgot Password?",
    RESET_FORGOT_MESSAGE: "Enter your email address and we'll send you a link to reset your password.",
    RESET_LABEL_EMAIL: "Email Address",
    RESET_PLACEHOLDER_EMAIL: "Enter your email",
    RESET_SEND_LINK: "Send Reset Link",
    RESET_CHECK_EMAIL_TITLE: "Check Your Email",
    RESET_EMAIL_SENT_PREFIX: "We've sent a password reset link to",
    RESET_EMAIL_SENT_SUFFIX: "Click the link in your email to reset your password. The link will expire in 1 hour.",
    RESET_DIDNT_RECEIVE: "Didn't receive the email? Try again",
    RESET_NEW_PASSWORD_TITLE: "Reset Your Password",
    RESET_NEW_PASSWORD_MESSAGE: "Enter your new password below.",
    RESET_LABEL_NEW_PASSWORD: "New Password",
    RESET_PLACEHOLDER_NEW_PASSWORD: "Enter new password",
    RESET_LABEL_CONFIRM_PASSWORD: "Confirm New Password",
    RESET_PLACEHOLDER_CONFIRM_PASSWORD: "Confirm new password",
    RESET_BUTTON: "Reset Password",
    RESET_SUCCESS_TITLE: "Password Reset Successful",
    RESET_SUCCESS_MESSAGE: "Your password has been successfully reset. You can now log in with your new password.",
    RESET_CONTINUE_LOGIN: "Continue to Login",
    RESET_ERROR_ENTER_EMAIL: "Please enter your email address",
    RESET_ERROR_SEND_FAILED: "Failed to send password reset email. Please try again.",
    RESET_ERROR_PASSWORDS_MISMATCH: "Passwords do not match",
    RESET_ERROR_FAILED: "Failed to reset password. Please try again.",
    
    // Password Validation Errors
    PASSWORD_ERROR_MIN_LENGTH: "Password must be at least 8 characters long",
    PASSWORD_ERROR_UPPERCASE: "Password must contain at least one uppercase letter",
    PASSWORD_ERROR_LOWERCASE: "Password must contain at least one lowercase letter",
    PASSWORD_ERROR_DIGIT: "Password must contain at least one digit",
    PASSWORD_ERROR_SPECIAL: "Password must contain at least one special character (!@#$%^&*()_+-=[]{}|;:,.<>?)",
}

export const FOOTER = {
    PRIVACY: "Privacy",
    TERMS: "Terms",
    SUPPORT: "Support",
    COPYRIGHT: "© 2025 Experience",
}

export const CARDS = {
    // List Card
    LIST_BADGE_SYSTEM: "System",
    LIST_BADGE_PRIVATE: "Private",
    LIST_BADGE_PUBLIC: "Public",
    LIST_BADGE_OWNER: "Owner",
    LIST_MEMBER: "member",
    LIST_MEMBERS: "members",
    LIST_CREATED: "Created",
    LIST_UPDATED: "Updated",
    
    // User Card
    USER_UNKNOWN: "Unknown User",
    USER_USERNAME_PREFIX: "@",
    USER_DEFAULT_USERNAME: "username",
    USER_BADGE_VERIFIED: "Verified",
    USER_STAT_FOLLOWERS: "followers",
    USER_STAT_POSTS: "posts",
    USER_STAT_SUBSCRIPTIONS: "subscriptions",
}

export const IMAGE_EDITOR = {
    TITLE_PROFILE: "Edit Profile Picture",
    TITLE_BANNER: "Edit Banner Image",
    INSTRUCTION_PROFILE: "Drag to adjust the crop area. The image will be cropped to a square (1:1) aspect ratio.",
    INSTRUCTION_BANNER: "Drag to adjust the crop area. The image will be cropped to a banner (16:9) aspect ratio.",
    BUTTON_CANCEL: "Cancel",
    BUTTON_SAVE: "Save",
    ALT_CROP_PREVIEW: "Crop preview",
}

export const MEDIA_MODAL = {
    CLOSE_BUTTON: "Close (ESC)",
    PREVIOUS_BUTTON: "Previous (←)",
    NEXT_BUTTON: "Next (→)",
    ALT_MEDIA_VIEWER: "Media viewer",
    COUNTER_OF: "of",
}

export const MEDIA_VIEWER = {
    // Default values
    DEFAULT_ALT: "Media",
    
    // Processing states
    PROCESSING_CONTENT: "Processing content...",
    PROCESSING_SUBTITLE: "This may take a few moments",
    
    // Review states
    UNDER_REVIEW: "Under review...",
    MANUAL_REVIEW: "Manual review in progress",
    
    // Error states
    CONTENT_FAILED: "Content processing failed",
    TRY_UPLOAD_AGAIN: "Please try uploading again",
    CONTENT_NOT_APPROVED: "Content not approved",
    DEFAULT_REJECTION_REASON: "Content violates community guidelines",
    MEDIA_NOT_AVAILABLE: "Media can't be displayed",
    FAILED_TO_LOAD: "Failed to load media",
    TAP_TO_RELOAD: "Tap to reload",
    UNSUPPORTED_TYPE: "Unsupported media type",
    
    // Audio
    AUDIO_CONTENT: "Audio Content",
}

export const MEDIA_GRID = {
    // Empty states
    UPLOADING_MEDIA: "Uploading media...",
    NO_MEDIA_SELECTED: "No media selected",
    UPLOADING: "Uploading...",
    
    // File types
    FILE: "File",
    
    // Format errors
    IMAGE_FORMAT_NOT_SUPPORTED: "Image format not supported",
    VIDEO_FORMAT_NOT_SUPPORTED: "Video format not supported",
    AUDIO_FORMAT_NOT_SUPPORTED: "Audio format not supported",
    
    // Upload states
    UPLOAD_FAILED: "Upload failed",
    PROCESSING: "Processing...",
    
    // Video thumbnail
    SELECT_VIDEO_COVER: "Select video cover",
    COVER: "Cover",
    
    // Status messages
    TAP_TO_SET_FREE_PREVIEWS: "Tap media items to set as free previews. All others are locked content.",
    FREE: "free",
    LOCKED: "locked",
}

export const PRICING = {
    MESSAGE_PRICE_LABEL: "Message Price",
    PRICE_PLACEHOLDER: "0.00",
}

export const VIDEO_THUMBNAIL = {
    TITLE: "Select Video Cover",
    INSTRUCTIONS: "Choose which frame to use as the video preview thumbnail",
    FRAME_PREFIX: "Frame",
    FRAMES_AVAILABLE_SUFFIX: "preview frames available",
    DONE_BUTTON: "Done",
}

export const FILE_UPLOAD = {
    // Error messages
    FILE_TOO_LARGE_PREFIX: "File too large:",
    FILE_TOO_LARGE_SUFFIX: "Try a smaller file or compress it.",
    UNSUPPORTED_FILE_TYPE: "Unsupported file type:",
    AUTH_REQUIRED: "Authentication required. Please log in again.",
    PERMISSION_DENIED: "Permission denied. You may not have permission to upload files.",
    UPLOAD_FAILED: "Upload failed. Please try again later.",
    IMAGE_PROCESS_FAILED: "Failed to process image. Please try a different format.",
    VIDEO_FORMAT_NOT_SUPPORTED: "Video format not supported:",
    VIDEO_SUPPORTED_FORMATS: "Please use MP4, MOV, AVI, FLV, or WMV format.",
    INVALID_FILE_TYPE: "Invalid file type:",
    MAX_SIZE_LIMIT: "Maximum size is 10GB.",
    MAX_FILES_PREFIX: "Maximum",
    MAX_FILES_SUFFIX: "files allowed",
    VIDEO_TOO_LARGE_TIP: "Try trimming the video or recording at a lower resolution (1080p instead of 4K).",
    VIDEO_SELECTION_FAILED: "Video couldn't be loaded. It may be too long or too large for your device to process. Try a shorter clip or lower resolution.",
}

export const SEARCH = {
    DEFAULT_PLACEHOLDER: "Search...",
    SEARCHING: "Searching...",
    MIN_CHARS_PREFIX: "Enter at least",
    MIN_CHARS_SUFFIX: "characters to search",
}

export const NOTIFICATION = {
    // Loading
    LOADING: "Loading notifications",
    LOADING_TAB: "Loading",
    LOADING_MORE: "Loading more...",

    // Header
    UNREAD_SUFFIX: "unread",
    MARK_ALL_READ: "Mark all read",

    // Empty State
    EMPTY_TITLE: "You're all caught up!",
    EMPTY_SUBTITLE_ALL: "No notifications yet. When you get them, they'll show up here.",
    EMPTY_SUBTITLE_CATEGORY: "No {category} notifications.",

    // Toasts
    TOAST_NEW_NOTIFICATION: "New notification",
    TOAST_FETCH_ERROR: "Failed to load notifications",
    TOAST_MARK_ALL_READ_SUCCESS: "All notifications marked as read",
    TOAST_MARK_ALL_READ_ERROR: "Failed to mark all as read",
    TOAST_FOLLOWED_BACK: "Followed back!",
    TOAST_ACTION_FAILED: "Action failed",

    // Inline
    ACTION_LOADING: "...",
    GROUP_FALLBACK_ENTITY: "content",
}

export const POST = {
    // Visibility labels
    VISIBILITY_PUBLIC: "Public",
    VISIBILITY_SUBSCRIBERS_ONLY: "Subscribers Only",
    VISIBILITY_FOLLOWERS_ONLY: "Followers Only",

    // Visibility descriptions
    VISIBILITY_PUBLIC_DESC: "This post is visible to everyone, including non-followers.",
    VISIBILITY_SUBSCRIBERS_DESC: "This post is only visible to your subscribers.",
    VISIBILITY_FOLLOWERS_DESC: "This post is only visible to your followers and subscribers.",

    // Post type tooltips
    SUBSCRIBERS_ONLY_TOOLTIP: "This is exclusive content for subscribers only. Subscribe to this creator to unlock it.",
}

export const CONTENT_FILTER = {
    PROHIBITED_WORD_ERROR: "Text contains words not allowed on Experience Platform",
    IMAGE_MODERATION_REJECTED: "This image is not allowed on Experience Platform. Please upload an appropriate image.",
}

export const VIBE = {
    // Vibe types
    VIBE_SHARE: "Share a vibe",
    VIBE_VIDEO: "Video",
    VIBE_AUDIO: "Audio",
    VIBE_IMAGE: "Image",
    VIBE_TEXT: "Text",
    VIBE_LINK: "Link",
    VIBE_PREVIEW_IN_PROGRESS: "Preparing preview…",
    VIBE_RETRY: "Retry",
    VIBE_CANCEL: "Cancel",
    VIBE_SHARING: "Sharing…",
    VIBE_UPLOADING: "Uploading…",
    VIBE_CREATION_HINT: "Vibes disappear after 24 hours",
    VIBE_PICK_TITLE: "Pick a photo or short video",
    VIBE_CHOOSE_FROM_DEVICE: "Choose from device",
    // iOS Safari can't run our in-browser video trimmer (no captureStream +
    // ffmpeg.wasm can't decode iPhone HEVC clips), so long videos are routed
    // to a helper that walks the user through Photos' built-in trim.
    VIBE_TRIM_IOS_TITLE: "Trim your video first",
    VIBE_TRIM_IOS_PICK_ANOTHER: "Pick another video",

}

export const BULK_MESSAGE = {
    // Page titles
    PAGE_TITLE: "New Message",
    COMPOSE_TITLE: "Compose",
    BACK_BUTTON: "Back",

    // Tabs
    TAB_CIRCLES: "User Circles",
    TAB_CIRCLES_SUBTITLE: "Send to predefined user circles",
    TAB_USERS: "Individual Users",
    TAB_USERS_SUBTITLE: "Search and select specific users",
    TAB_EXCEPTIONS: "Exception Circles",
    TAB_EXCEPTIONS_SUBTITLE: "Exclude users from selected circles",

    // Search placeholders
    SEARCH_CIRCLES: "Search circles...",
    SEARCH_USERS: "Search users by name or username...",
    SEARCH_EXCEPTIONS: "Search exception circles...",

    // Empty states - Circles
    NO_CIRCLES_FOUND: "No circles found",
    NO_CIRCLES_AVAILABLE: "No circles available",
    NO_CIRCLES_FOUND_HINT: "Try adjusting your search terms.",
    NO_CIRCLES_AVAILABLE_HINT: "Create some user circles first to send bulk messages.",

    // Empty states - Users
    NO_USERS_FOUND: "No users found",
    NO_USERS_FOUND_HINT: "Try searching with different terms.",
    SEARCH_FOR_USERS: "Search for users",
    SEARCH_FOR_USERS_HINT: "Start typing to search for users to send messages to.",
    SEARCH_MIN_CHARS: "Enter at least 2 characters to search for users",
    SEARCHING_USERS: "Searching users...",

    // Empty states - Exceptions
    NO_LISTS_FOUND: "No circles found",
    NO_LISTS_AVAILABLE: "No circles available",
    NO_LISTS_FOUND_HINT: "Try adjusting your search terms.",
    NO_LISTS_AVAILABLE_HINT: "Create some user circles first to use as exceptions.",

    // Searching
    SEARCHING_LISTS: "Searching lists...",

    // Selected users
    SELECTED_LABEL: "Selected",

    // Recipient summary
    CIRCLE: "circle",
    CIRCLES: "circles",
    USER: "user",
    USERS: "users",
    EXCLUDED: "excluded",
    RECIPIENTS_PREFIX: "~",
    RECIPIENTS_SUFFIX: "recipients",

    // Compose button
    COMPOSE_MESSAGE: "Compose Message",

    // Welcome
    WELCOME_TITLE: "Ready to send a message?",
    WELCOME_TEXT: "Select recipient circles or individual users to get started.",

    // Progress
    PROCESSING_BULK: "Processing bulk operation...",
    PROGRESS_COMPLETE_SUFFIX: "% complete",
    QUEUED_SUCCESS: "Message queued successfully! Processing in background...",
    QUEUED_NAV_HINT: "You can navigate to Messages or compose another message.",
    VIEW_MESSAGES: "View Messages",

    // Toast messages
    TOAST_EMPTY_MESSAGE: "Please enter a message or add media before sending.",
    TOAST_NO_RECIPIENTS: "Please select at least one recipient circle or user.",
    TOAST_SEND_FAILED: "Failed to send message. Please try again.",
    TOAST_TIMEOUT: "Message sending timed out. Check your message history for status.",
}